import { createSlice } from '@reduxjs/toolkit'

import { DEFAULT_VERSION_TABLE, HISTORY_TABS } from '../../containers/history/constants'
import { historyPageSelectors } from '../selectors/historyPage'

const initialState = {
    activeTab: HISTORY_TABS.export,
    selectedGroupId: '',
    selectedGroupName: '',
    saveOnServer: false,
    activeVersionId: null,
    versionTable: DEFAULT_VERSION_TABLE,
}

const historyPage = createSlice({
    name: 'historyPage',
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload
        },
        setExportGroup: (state, action) => {
            state.selectedGroupId = action.payload.groupId
            state.selectedGroupName = action.payload.groupName
        },
        setSaveOnServer: (state, action) => {
            state.saveOnServer = action.payload
        },
        openVersion: (state, action) => {
            state.activeVersionId = action.payload.versionId
            state.versionTable = DEFAULT_VERSION_TABLE
        },
        closeVersion: (state) => {
            state.activeVersionId = null
            state.versionTable = DEFAULT_VERSION_TABLE
        },
        setVersionTable: (state, action) => {
            state.versionTable = action.payload
        },
        resetPage: () => initialState,
    },
    selectors: {
        ...historyPageSelectors,
    },
})

export const historyPageSelector = historyPage.getSelectors()
export const historyPageActions = historyPage.actions

export default historyPage.reducer
